export type EventRecord = {
  slug: string
  type: string
  title: string
  description: string
  date: string
  time: string
  venue: string
  address: string
  city: string
  state: string
  image: string
  speakers: string[]
  capacity: string
  livestream: boolean
  past?: boolean
}

const rally =
  'https://cdn.magicpatterns.com/patterns/generated-images/23fed40f-ca99-4026-a7ba-476691c2f191.jpg'
const townhall =
  'https://cdn.magicpatterns.com/patterns/generated-images/93340211-d03b-4760-9807-29ce94192f52.jpg'
const tech =
  'https://cdn.magicpatterns.com/patterns/generated-images/bd5404b8-d7a4-46e6-9892-2f8d1b841d5a.jpg'
const farm =
  'https://cdn.magicpatterns.com/patterns/generated-images/e8e04d27-df9c-4881-b697-26bf91fc9f04.jpg'
const health =
  'https://cdn.magicpatterns.com/patterns/generated-images/20eced12-a4a9-46f7-8597-99c0c458533b.jpg'

export const eventTypes = [
  'All Events',
  'Rallies',
  'Town Halls',
  'Press Events',
  'Virtual Events',
  'Campaign Meetings',
]

export const events: EventRecord[] = [
  {
    slug: 'abuja-town-hall-jobs',
    type: 'Town Halls',
    title: 'Presidential Town Hall on Jobs & Enterprise',
    description:
      'An unscripted ninety minutes with employers, apprentices and jobseekers on what it will take to create five million formal jobs — and how progress will be measured publicly.',
    date: 'Saturday, 29 August 2026',
    time: '6:00 PM — 8:00 PM WAT',
    venue: 'Transcorp Hilton',
    address: '1 Aguiyi Ironsi Street, Maitama, Abuja',
    city: 'Abuja',
    state: 'FCT',
    image: townhall,
    speakers: ['Adebayo S. Bello', 'Dr. Hauwa Ibrahim, Policy Director', 'Employers’ panel'],
    capacity: '1,200 seats · registration required',
    livestream: true,
  },
  {
    slug: 'lagos-founders-forum',
    type: 'Virtual Events',
    title: 'Building From Home: A Conversation With Founders',
    description:
      'A working session with technology founders on broadband, power, procurement and regulatory response times, streamed live nationwide.',
    date: 'Wednesday, 2 September 2026',
    time: '4:00 PM — 5:30 PM WAT',
    venue: 'Landmark Event Centre',
    address: 'Water Corporation Drive, Victoria Island, Lagos',
    city: 'Lagos',
    state: 'Lagos',
    image: tech,
    speakers: ['Adebayo S. Bello', 'Founders’ roundtable'],
    capacity: '400 in person · unlimited online',
    livestream: true,
  },
  {
    slug: 'maiduguri-unity-rally',
    type: 'Rallies',
    title: 'North East Unity Rally',
    description:
      'A public rally on reconstruction, resettlement with land title and the reopening of schools across the North East.',
    date: 'Saturday, 5 September 2026',
    time: '10:00 AM — 1:00 PM WAT',
    venue: 'Ramat Square',
    address: 'Post Office Area, Maiduguri, Borno State',
    city: 'Maiduguri',
    state: 'Borno',
    image: rally,
    speakers: ['Adebayo S. Bello', 'North East campaign leadership'],
    capacity: 'Open to the public',
    livestream: false,
  },
  {
    slug: 'makurdi-farmers-meeting',
    type: 'Campaign Meetings',
    title: 'Middle Belt Farmers’ Roundtable',
    description:
      'A closed roundtable with farming cooperatives and displaced families on the rural security corps and mechanisation rollout.',
    date: 'Tuesday, 8 September 2026',
    time: '11:00 AM — 1:00 PM WAT',
    venue: 'Benue State Cooperative Hall',
    address: 'Old GRA, Makurdi, Benue State',
    city: 'Makurdi',
    state: 'Benue',
    image: farm,
    speakers: ['Adebayo S. Bello', 'Agriculture policy team'],
    capacity: 'Invitation only',
    livestream: false,
  },
  {
    slug: 'kano-health-walkthrough',
    type: 'Press Events',
    title: 'Primary Healthcare Walkthrough & Press Briefing',
    description:
      'A visit to two ward-level primary healthcare centres followed by a press briefing on the facility readiness audit.',
    date: 'Friday, 11 September 2026',
    time: '9:00 AM — 12:00 PM WAT',
    venue: 'Dala PHC & Gwale PHC',
    address: 'Dala and Gwale LGAs, Kano State',
    city: 'Kano',
    state: 'Kano',
    image: health,
    speakers: ['Adebayo S. Bello', 'Health policy team'],
    capacity: 'Accredited media only',
    livestream: false,
  },
  {
    slug: 'enugu-manufacturers-forum',
    type: 'Town Halls',
    title: 'South East Manufacturers’ Forum',
    description:
      'Aba, Nnewi and Onitsha manufacturers on the industrial power compact and the proposed Enugu dry port.',
    date: 'Thursday, 20 August 2026',
    time: '10:00 AM — 12:30 PM WAT',
    venue: 'Nike Lake Resort',
    address: 'Abakpa Nike, Enugu State',
    city: 'Enugu',
    state: 'Enugu',
    image: townhall,
    speakers: ['Adebayo S. Bello', 'Manufacturers Association panel'],
    capacity: '600 seats',
    livestream: true,
    past: true,
  },
]

export function getEvent(slug: string): EventRecord | undefined {
  return events.find((event) => event.slug === slug)
}
